import { differenceInDays, format, isSameDay } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TimeFormatOptions } from 'shared/types/date-format-options';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

import * as Styled from './external-events-list.style';

export type ExternalEventsListProps = {
  events: ExternalCalendarEvent[];
  show?: boolean;
  timeFormat: TimeFormatOptions;
};

export const ExternalEventsList: React.FC<ExternalEventsListProps> = ({
  events,
  show = true,
  timeFormat,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Container $show={show} $items={events.length}>
      <Styled.List>
        {events.map((event) => {
          const startTime = new Date(event.start.dateTime ?? event.start.date);
          const endTime = new Date(event.end.dateTime ?? event.end.date);

          const label =
            (event.start.date &&
              event.end.date &&
              isSameDay(event.start.date, event.end.date)) ||
            differenceInDays(endTime, startTime)
              ? t('general.labels.all-day')
              : `${format(startTime, timeFormat)}-${format(endTime, timeFormat)}`;

          return (
            <Styled.ListItem key={event.id}>
              <Styled.EventContainer
                as={!event.url ? 'span' : undefined}
                href={event.url}
                target="_blank"
                rel="noreferrer"
              >
                <Styled.Color $color={event.color} />
                <Styled.Time>{label}</Styled.Time>
                <Styled.Title>{event.title}</Styled.Title>
              </Styled.EventContainer>
            </Styled.ListItem>
          );
        })}
      </Styled.List>
    </Styled.Container>
  );
};
